import React, { useState, useEffect, useCallback } from 'react';
import '../styles/theme.css';
import { useAuth } from '../hooks/useAuth';
import Button from '../components/Button';
import { viewPortfolioWatchList } from '../services/portfolio';
import { getToken } from '../services/auth';
import PortfolioSummary from '../components/PortfolioSummary';
import PortfolioCard from '../components/PortfolioCard';

const WelcomePage: React.FC = () => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [portfolios, setPortfolios] = useState<any[]>([]);

  const handleViewWatchlist = useCallback(async () => {
    if (user?.sub) {
      setIsLoading(true);
      setError(null);
      try {
        const token = await getToken();
        const userInfo = {
          org: 'OrgVQ',
          token: token || '',
        };
        
        const data = await viewPortfolioWatchList(user.sub, userInfo);
        // Filter portfolios with portStatus: "wl_live"
        const livePortfolios = data.filter((portfolio: any) => 
          portfolio.portStatus === "wl_live"
        );
        setPortfolios(livePortfolios);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch watchlist');
      } finally {
        setIsLoading(false);
      }
    }
  }, [user?.sub]);

  useEffect(() => {
    if (user?.sub) {
      handleViewWatchlist();
    }
  }, [user, handleViewWatchlist]);

  
  return (
    <div className="welcome-page" style={{ backgroundColor: '#f0f0f0', minHeight: '100vh', padding: '2rem' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <PortfolioSummary portfolios={portfolios} />

        {/* Quick Actions */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '2rem' }}>
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            <Button onClick={() => {}}>Add Portfolio</Button>
            <Button onClick={() => {}}>Import Holdings</Button>
            <Button onClick={() => {}}>Run Analysis</Button>
            <Button 
              onClick={handleViewWatchlist}
              disabled={isLoading}
            >
              {isLoading ? 'Loading...' : 'Refresh Watchlist'}
            </Button>
            {error && (
              <div style={{ 
                color: 'red',
                marginLeft: '10px',
                fontSize: '0.9em'
              }}>
                {error}
              </div>
            )}
          </div>
        </div>

        {/* Live Portfolios */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '1rem' }}>
          {portfolios.map((portfolio, index) => (
            <PortfolioCard key={index} portfolio={portfolio} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
